import { Buffer } from 'buffer';

// Make Buffer available globally for amazon-cognito-identity-js
if (typeof globalThis !== 'undefined') {
  (globalThis as typeof globalThis & { Buffer: typeof Buffer }).Buffer = Buffer;
} else if (typeof window !== 'undefined') {
  (window as typeof window & { Buffer: typeof Buffer }).Buffer = Buffer;
} else if (typeof global !== 'undefined') {
  (global as typeof global & { Buffer: typeof Buffer }).Buffer = Buffer;
}
